import { getPdfReport } from "../api/service/report";
import { printWorkOrder } from "../api/work-order";

/**
 * Følgeseddel (delivery note) PDF — report and work order use existing print_pdf with type "note".
 * Orders have no packing-slip endpoint in API yet; caller should hide the action for module "order".
 */
export async function quickPrintPackingSlip({ sourceType, sourceId }, { t } = {}) {
  if (!sourceId) {
    throw new Error(t ? t("inventory.picking.delivery_note.missing_id") : "Missing document");
  }

  let response;
  if (sourceType === "report") {
    response = await getPdfReport({
      id: sourceId,
      params: { printReportType: "note" },
    });
  } else if (sourceType === "work_order") {
    response = await printWorkOrder({
      id: sourceId,
      printWorkOrderType: "note",
    });
  } else {
    throw new Error(t ? t("inventory.picking.delivery_note.unsupported") : "Unsupported document type");
  }

  const pdfUrl = response?.data?.pdf_url;
  if (!pdfUrl) {
    throw new Error(t ? t("inventory.picking.delivery_note.failed") : "Could not create PDF");
  }

  window.open(pdfUrl, "_blank", "noopener,noreferrer");
}
